import React from "react";
import styled from "styled-components";
import { H5, Description } from "./typography";
import { HideMobile, ShowMobile } from "./blocks/Responsive";
import Image from "./Image";
import { getThemeColor } from "../utils";
import linkedinIcon from "../../assets/linkedin-icon.png";
import emailIcon from "../../assets/email-icon.png";
import Flex from "./blocks/Flex";

const Profile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

const Name = H5.extend`
  padding-top: 1rem;
  padding-bottom: .5rem;
`;

const Bio = styled.div`
  position: absolute;
  top: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: .5rem 1rem;
  color: white;
  font-size: .8rem;
  line-height: 1.4;
  text-align: center;
  transition: opacity 500ms;
  cursor: pointer;

  &:hover,
  &:active {
    opacity: .55;
    background-color: ${getThemeColor("purpleDark")};
  }
`;

const ImageFull = styled.img`
  width: 100%;
  display: flex;
`;

const Overlay = styled.div`position: relative;`;

const Picture = ({ person = {}, select }) =>
  <Profile onClick={() => select(person)}>
    {person.src &&
      <Overlay>
        <ImageFull src={person.src} align="flex-start" full={true} />
        <Bio>
          View {person.name.split(" ")[0]}'s bio
        </Bio>
      </Overlay>}
    <Name serif>
      {person.name}
    </Name>
    <Description>
      {person.description}
    </Description>
  </Profile>;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 3rem 0.5rem;
  padding: ${({ padLarge }) => (padLarge ? "4rem 2rem" : "0rem 2rem")};
  ${props => props.theme.media.tablet`
    grid-template-columns: repeat(2, 1fr);
  `};

  ${props => props.theme.media.mobile`
    grid-template-columns: repeat(1, 1fr);
    padding: 0;
  `};
`;

export default ({ persons = [], title = "", padLarge = false, selectPerson }) =>
  <Grid padLarge={padLarge}>
    {persons.map(person => <Picture person={person} select={selectPerson} />)}
  </Grid>;



// WEBPACK FOOTER //
// ./src/components/PictureGrid.js